import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Bell — notification preferences. */
export function BellIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M6.2 15.8v-4.6a5.8 5.8 0 0 1 11.6 0v4.6l1.7 2.4H4.5l1.7-2.4Z" />
      <path d="M10 20.6a2.2 2.2 0 0 0 4 0" />
    </PortalIcon>
  );
}
